import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { Loader2 } from "lucide-react";

interface ProtectedRouteProps {
  children: React.ReactNode;
  requireModify?: boolean;
  requireAdmin?: boolean;
}

const ProtectedRoute = ({ children, requireModify = false, requireAdmin = false }: ProtectedRouteProps) => {
  const { user, loading, hasDashboardAccess, canModify, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen bg-primary flex items-center justify-center">
        <Loader2 className="w-8 h-8 text-secondary animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!hasDashboardAccess) {
    return (
      <div className="min-h-screen bg-primary flex items-center justify-center p-4" dir="rtl">
        <div className="text-center text-white">
          <h1 className="text-2xl font-bold mb-4">אין לך הרשאה לגשת לדשבורד</h1>
          <p className="text-white/60 mb-6">פנה למנהל המערכת לקבלת הרשאות</p>
          <a href="/" className="text-secondary hover:text-secondary/80">
            חזרה לאתר הראשי
          </a>
        </div>
      </div>
    );
  }

  if (requireAdmin && !isAdmin) {
    return <Navigate to="/dashboard" replace />;
  }

  if (requireModify && !canModify) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
